<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-11-29 14:16:09
 * @LastEditors  : 侯鹏许(houpengxu@qq.com)
 * @LastEditTime : 2020-01-16 10:32:47
 * @Description: file content
 -->
<template>

  <div class="btn_home" @click="goPage">
    返回
    <!-- <img :src="'http://assets.rurushishi.com/activies/tcygc-bird-2021-06/' + 'goBack.png?v=2'" /> -->

  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    goPage() {
      if (this.$route.name === 'dzp') {
        this.$router.go(-2)
      } else {
        this.$router.go(-1)
      }
    }
  },
  created() {
   
  },
  mounted() {}
};
</script>
<style lang="css" scoped>
.btn_home {
  width: 48px;
  height: 48px;
  position: fixed;
  bottom: 60px;
  right: 12px;
  z-index: 100;
  background-color: #FDB43A;
  color: #fff;
  font-size: 14px;
  line-height: 48px;
  text-align: center;
  border-radius: 24px;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);
}

.btn_home > img {
  width: 100%;
}
</style>